import React, { useState, useEffect } from 'react'
import { useOutletContext } from 'react-router-dom'
import Table, { Row, Cell } from '../components/Table.js'
import Editor from './Type/Editor.js'

export default () => {

    const [id, setID] = useState()
    const [types, setTypes] = useState([])
    const [editor, setEditor] = useState(false)
    const context = useOutletContext()

    const handleLoad = async () => {
        setTypes(
            await context.api.panel.get('/типи')
        )
    }


    useEffect(async () => {
        context.setMeta({
            title: 'Типи',
            submenu: [{
                title: 'Створити', 
                onClick: () => setEditor(true)
            }]
        })
        handleLoad()
    }, [])

    return <>
        <Table columns={['Назва', 'Посилання', 'Сортування']}>
            {types.map(type => (
                <Row status={type.status} key={type._id}
                    onClick={() => {setID(type._id);setEditor(true)}}>
                    <Cell align="left">{type.title}</Cell>
                    <Cell align="left">{type.slug}</Cell>
                    <Cell align="center">{type.sort}</Cell>
                </Row>
            ))}
        </Table>
        {editor && <Editor id={id} onSubmit={handleLoad}
            show={editor} onHide={() => {setID();setEditor(false)}} />}
    </>
}